import { format, startOfWeek, endOfWeek, subWeeks } from "date-fns";

/**
 * Rótulo do intervalo de uma semana (segunda a domingo) no formato "dd/MM a dd/MM".
 * semanaAtual=false retorna a semana anterior completa.
 * Usado apenas para exibição; o backend calcula o range real.
 */
export const formatIntervaloSemana = (semanaAtual: boolean): string => {
  const base = semanaAtual ? new Date() : subWeeks(new Date(), 1);
  const inicio = startOfWeek(base, { weekStartsOn: 1 });
  const fim = endOfWeek(base, { weekStartsOn: 1 });
  return `${format(inicio, "dd/MM")} a ${format(fim, "dd/MM")}`;
};
